import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Tracks from 'Containers/Tracks'
import { influencerBoard } from './routes'

export const InfluencerComponents = () => (
  <Switch>
    <Route component={Tracks} exact path={influencerBoard} />
    <Route component={Tracks} path="*" />
  </Switch>
)
